export default __webpack_public_path__ + "static/media/onboarding2.2f16d1a6.webp";